var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card d-flex flex-column align-items-center",attrs:{"shadow":"never"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }